import React, { useState } from "react";
import "./UploadImage.css";
import { ref, uploadBytesResumable, getDownloadURL } from "@firebase/storage";
import { collection, addDoc, doc, setDoc } from "@firebase/firestore";
import { projectStorage, projectFirestoreDB } from "../firebase/config";
import { useAuth } from "../components/contexts/AuthContext";
import { Link } from "react-router-dom";

const UploadImage = () => {
  const [file, setFile] = useState(null);
  const [fileURL, setFileURL] = useState(null);
  const [error, setError] = useState(null);
  const [fileIdUrl, setfileIdUrl] = useState(null);

  const types = ["image/png", "image/jpeg"];

  const { currentUser } = useAuth();

  const handleChangePreview = (e) => {
    let selected = e.target.files[0];

    if (selected && types.includes(selected.type)) {
      setFile(selected);
      setFileURL(URL.createObjectURL(selected));
      setError("");
    } else {
      setFile(null);
      setError("Please select an image file (png or jpg)");
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (file != null) {
      let storageRef = ref(projectStorage, file.name);
      let uploadTask = uploadBytesResumable(storageRef, file);
      const collectionRef = collection(
        projectFirestoreDB,
        "users",
        currentUser.uid,
        "memes"
      );

      let fileId = null;

      // to be able to see the actual date it was uploaded
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      today = yyyy + "." + mm + "." + dd;

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (err) => {
          setError(err);
        },
        () => {
          // Upload completed successfully, now we can get the download URL
          getDownloadURL(storageRef)
            .then(async (downloadURL) => {
              console.log("File available at: ", downloadURL);
              // Adds doc to the cloud firestore also (later used to show all memes)
              // can send same image multiple times?
              const docRef = doc(collection(projectFirestoreDB, "memeImages"));
              setDoc(doc(projectFirestoreDB, "memeImages", docRef.id), {
                title: document.getElementById("memeTitle").value, // not nice way to do it but I leave it as it is now (takes from form directly)
                url: downloadURL,
                createdAt: Date.now(),
                createdBy: currentUser.uid,
                createdAtyyyyMMdd: today,
                isMinted: false,
              });
              setDoc(doc(projectFirestoreDB, "memeImagesasNFTs", docRef.id), {
                // here is all information that is displayed publicly via a minted NFT
                name: document.getElementById("memeTitle").value,
                description: document.getElementById("memeDesc").value,
                image: downloadURL,
                image_mimetype: "image/png",
                external_url: "https://mema-3473f.web.app/gallery/" + docRef.id,
              });

              addDoc(collectionRef, {
                url: downloadURL,
                createdAt: Date.now(),
              });

              // removes the file so it is not previewed anymore, and also as selected, so you can't press upload twice in a row
              fileId = docRef.id;
              setfileIdUrl(docRef.id);
              setFile(null);
              setFileURL(null);
            })
            .then(() => {
              console.log(fileId);
              //window.location = "/gallery/" + fileId;
            });
        }
      );
    }
  };

  return (
    <div className="uploadForm">
      <form onSubmit={handleUpload}>
        <p>Add an image:</p>
        <label className="custom-file-upload">
          <input type="file" onChange={handleChangePreview} required />
          <span>+</span>
        </label>
        <img src={fileURL}></img>

        <div className="output">
          {error && <div className="error">{error}</div>}
          {file && <div>{file.name}</div>}
          {fileIdUrl && (
            // Just to have some sort of pointer to the new uploaded page, will need to be fixed so it happens automatically
            <Link to={"gallery/" + fileIdUrl}>
              Here is your uploaded image: {fileIdUrl}
            </Link>
          )}
        </div>
        <label>Title</label>
        <input
          type="text"
          id="memeTitle"
          placeholder="Your title"
          required
        ></input>
        <label>Description</label>
        <input
          type="text"
          id="memeDesc"
          placeholder="Your description (optional)"
        ></input>
        <input
          type="submit"
          value="Upload"
          //onClick={handleUpload()} // document.getElementById("memeTitle") $('#memeTitle').val()
        ></input>
      </form>
    </div>
  );
};

export default UploadImage;
